import { Base } from "../../framework/base";
import { AppUtils } from "../common/appUtils";
import {
    DayBookingState,
    DayBookingUsageType,
    EnumHelper,
    StrMeasureUnit,
} from "../common/enums";

export class DayBookingItemBeta {
    id: string;
    rowId: string;
    employeeId: string;
    dayBookingTypeId: string;
    costCenterId: string;
    costCenterName: string;
    vehicleId: string;
    vehicleName: string;
    day: string;
    endDay: string;
    amount: number;
    bookingType: number;
    dayUsageType: DayBookingUsageType;
    comment: string;
    dayHoursRatio: number;
    salaryRowTypeId: string;
    salaryRowTypeMeasureUnit: StrMeasureUnit;
    salaryRowTypeDecimals: number;
    state: number;
    automaticCategory?: string;
    automaticWorkShiftTimeSlotId?: string;

    constructor(obj?: any) {
        this.id = (obj && obj.id) || "";
        this.rowId = (obj && obj.rowId) || "";
        this.employeeId = (obj && obj.employeeId) || "";
        this.dayBookingTypeId = (obj && obj.dayBookingTypeId) || "";
        this.costCenterId = (obj && obj.costCenterId) || "";
        this.costCenterName = (obj && obj.costCenterName) || "";
        this.vehicleId = (obj && obj.vehicleId) || "";
        this.vehicleName = (obj && obj.vehicleName) || "";
        this.day = (obj && obj.day) || "";
        this.endDay = (obj && obj.endDay) || "";
        this.amount = (obj && obj.amount) ?? 1;
        this.bookingType = (obj && obj.bookingType) || 0;
        this.dayUsageType = (obj && obj.dayUsageType) || 0;
        this.comment = (obj && obj.comment) || "";
        this.dayHoursRatio = (obj && obj.dayHoursRatio) || 8;
        this.salaryRowTypeId = (obj && obj.salaryRowTypeId) || "";
        this.salaryRowTypeMeasureUnit =
            (obj && obj.salaryRowTypeMeasureUnit) || "";
        this.salaryRowTypeDecimals = (obj && obj.salaryRowTypeDecimals) || 0;
        this.state = (obj && obj.state) ?? 0;
        this.automaticCategory = obj && obj.automaticCategory;
        this.automaticWorkShiftTimeSlotId =
            obj && obj.automaticWorkShiftTimeSlotId;
    }

    getEndDay(): string {
        return this.endDay;
    }

    isLocked(): boolean {
        return EnumHelper.isEqual(this.state, DayBookingState.Locked);
    }
}

export const getDurationStrBasedOnUnit = (
    amount: number,
    dayUsageType: DayBookingUsageType,
    dayHoursRatio: number,
    salaryRowTypeMeasureUnit: string,
    onlyOneDay = false
): string => {
    if (
        dayUsageType === DayBookingUsageType.NotFullDay &&
        AppUtils.isTimeUnit(salaryRowTypeMeasureUnit)
    ) {
        return AppUtils.getDurationStrByDurationMinShort(
            Base.hoursToMinutes(amount)
        );
    }

    return getDurationBasedOnUnit(
        amount,
        dayUsageType,
        dayHoursRatio,
        salaryRowTypeMeasureUnit,
        onlyOneDay
    ).toString();
};

const getDurationBasedOnUnit = (
    amount: number,
    dayUsageType: DayBookingUsageType,
    dayHoursRatio: number,
    salaryRowTypeMeasureUnit: string,
    onlyOneDay = false
): number => {
    if (dayUsageType === DayBookingUsageType.FullDay) {
        if (AppUtils.isTimeUnit(salaryRowTypeMeasureUnit)) {
            return onlyOneDay ? dayHoursRatio : amount * dayHoursRatio;
        } else if (onlyOneDay) {
            return 1; // If not time unit, amount for full day is always 1
        }
    } else if (
        dayUsageType === DayBookingUsageType.NotFullDay &&
        !AppUtils.isTimeUnit(salaryRowTypeMeasureUnit)
    ) {
        if (salaryRowTypeMeasureUnit === StrMeasureUnit.Piece.toString())
            return amount;
        return amount / dayHoursRatio;
    }

    return amount;
};
